'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.changePassword = exports.getUser = exports.logout = exports.login = undefined;

var _methods = require('./methods');

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var login = function () {
  var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(account, password) {
    var _ref2, user, status, error;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return (0, _methods.post)({
              url: '/api/auth/login',
              data: { account: account, password: password }
            });

          case 3:
            _ref2 = _context.sent;
            user = _ref2.data;
            return _context.abrupt('return', user);

          case 8:
            _context.prev = 8;
            _context.t0 = _context['catch'](0);

            // TOREFINE throw an error object
            status = _context.t0.status;
            error = void 0;

            if (status === 400) {
              error = 'fail';
            } else {
              error = 'error';
            }
            throw error;

          case 14:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, undefined, [[0, 8]]);
  }));

  return function login(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

var logout = function () {
  var _ref3 = _asyncToGenerator(regeneratorRuntime.mark(function _callee2() {
    var status, error;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            _context2.next = 3;
            return (0, _methods.post)({ url: '/api/auth/logout' });

          case 3:
            _context2.next = 11;
            break;

          case 5:
            _context2.prev = 5;
            _context2.t0 = _context2['catch'](0);

            // TOREFINE throw an error object
            status = _context2.t0.status;
            error = void 0;

            if (status === 400) {
              error = 'fail';
            } else {
              error = 'error';
            }
            throw error;

          case 11:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, undefined, [[0, 5]]);
  }));

  return function logout() {
    return _ref3.apply(this, arguments);
  };
}();

var getUser = function () {
  var _ref4 = _asyncToGenerator(regeneratorRuntime.mark(function _callee3() {
    var _ref5, user, status, error;

    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            _context3.next = 3;
            return (0, _methods.get)({ url: '/api/me' });

          case 3:
            _ref5 = _context3.sent;
            user = _ref5.data;
            return _context3.abrupt('return', user);

          case 8:
            _context3.prev = 8;
            _context3.t0 = _context3['catch'](0);
            status = _context3.t0.status;
            error = void 0;

            if (status === 401) {
              error = 'fail';
            } else {
              error = 'error';
            }
            throw error;

          case 14:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, undefined, [[0, 8]]);
  }));

  return function getUser() {
    return _ref4.apply(this, arguments);
  };
}();

var changePassword = function () {
  var _ref6 = _asyncToGenerator(regeneratorRuntime.mark(function _callee4(userId, oldPassword, password) {
    var url, data, status, error;
    return regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.prev = 0;
            url = '/api/auth/password';
            data = { old: oldPassword, new: password };
            _context4.next = 5;
            return (0, _methods.post)({ url: url, data: data });

          case 5:
            return _context4.abrupt('return', 'success');

          case 8:
            _context4.prev = 8;
            _context4.t0 = _context4['catch'](0);
            status = _context4.t0.status;
            error = void 0;

            if (status === 400) {
              error = 'fail';
            } else {
              error = 'error';
            }
            throw error;

          case 14:
          case 'end':
            return _context4.stop();
        }
      }
    }, _callee4, undefined, [[0, 8]]);
  }));

  return function changePassword(_x3, _x4, _x5) {
    return _ref6.apply(this, arguments);
  };
}();

exports.login = login;
exports.logout = logout;
exports.getUser = getUser;
exports.changePassword = changePassword;


//////////////////
// WEBPACK FOOTER
// ./~/coact/utils/codev-api/auth.js
// module id = 1051
// module chunks = 0